import RichContentEditor from './rich-content-editor-lazy';

export default RichContentEditor;
